import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { SearchOutlined } from '@ant-design/icons'
import { Input } from 'antd'
import { escapeRegExp } from 'lodash-es'
import { useSelector } from 'react-redux'
import { darkModeSelector } from 'app-redux/selectors'

function SearchWidget({
  onChange = () => {},
  onKeyDown = () => {},
  escape = false,
  autoFocus = true,
  ...props
}) {
  const { formatMessage } = useIntl()
  const darkMode = useSelector(darkModeSelector)

  const handleChange = useCallback(
    (e) => {
      if (escape) {
        e.target.value = escapeRegExp(e.target.value)
      }
      onChange(e)
    },
    [escape, onChange],
  )

  const handleKeyDown = useCallback(
    (e) => {
      if (escape) {
        e.target.value = escapeRegExp(e.target.value)
      }
      onKeyDown(e)
    },
    [escape, onKeyDown],
  )

  return (
    <Input
      prefix={<SearchOutlined style={{ color: darkMode ? '#B8BECA' : 'rgba(0,0,0,.25)' }} />}
      placeholder={formatMessage({ id: 'input.placeholder.search' })}
      id="input-search"
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      allowClear
      autoFocus={autoFocus}
      {...props}
    />
  )
}

export default SearchWidget
